import { QueryKeys } from "../../utils/queryKeys";

export const coursesKeys = {
    all: [QueryKeys.COURSES_TYPE_LIST],
    getCoursesKeys: (arg) => {
        const { languageid } = arg;

        return [...coursesKeys.all , languageid];
    },
};
